import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-view_more",
  "use": "icon-view_more-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 9 10\" id=\"icon-view_more\"><path fill=\"#0091FF\" fill-rule=\"evenodd\" d=\"M4.5 5.743 8.743 1.5 8.09.847 4.5 4.437.91.847.257 1.5zm0 4L8.743 5.5l-.653-.653-3.59 3.59-3.59-3.59-.653.653z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol